const TINY_MCE_API_KEY = "gwhopq19q5u8lxldbupsxk93ysqkxxujeo860maiqoristn1";

export default TINY_MCE_API_KEY;
